import { AuthLevel, generateApiPath } from '@guiker/api-definition'

const paths = {
  user: generateApiPath({ prefix: AuthLevel.ADMIN, name: 'user' }),
}

export { paths }
